import { Box } from '@mui/material';
import { ReactElement } from 'react';

/** As wide as the customer in the order list, and no wider, in both supplier tables (R-190). */
export const SUPPLIER_NAME_MAX_WIDTH = 420;
export const SUPPLIER_NAME_MIN_WIDTH = 240;

/** The supplier's name on one line, cut with "…" and given in full on hover. */
export const SupplierName = ({ name }: { name?: string }): ReactElement => (
    <Box
        component="span"
        title={name}
        sx={{
            display: 'block',
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}
    >
        {name}
    </Box>
);
